import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import Layout from "../components/Layout";
import Transaction from "../components/Transactions/Transaction";
import {
    searchFilter,
    TransactionTypeFilter
} from "../features/statementFilter/statementFilterSlice";
import { fetchTransactions } from "../features/transaction/transactionSlice";
import "./toggleStyle.css";

export default function Statement() {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const currentPage = searchParams.get("page") || 1;
  const [list, setList] = useState([]);
  const [pageCount, setPageCount] = useState(1);

  const {
    transaction: { transactions, isLoading, isError },
    statementFilter: { search, transactionType },
  } = useSelector((state) => state);

  function handleToggle(e) {
    if (e.target.checked) {
      dispatch(TransactionTypeFilter("income"));
    } else {
      dispatch(TransactionTypeFilter("expense"));
    }
  }

  function handleSearch(e) {
    dispatch(searchFilter(e.target.value));
  }

  function filter() {
    const list = transactions.filter(({ type, name }) => {
      if (type !== transactionType) return false;
      return name.includes(search);
    });
    setPageCount(Math.ceil(list.length / 5));
    setList(list.slice((currentPage - 1) * 5, currentPage * 5));
  }

  function Pagination() {
    const elements = [];
    for (let i = 1; i <= pageCount; i++) {
      elements.push(
        <button
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            // eslint-disable-next-line
            background: currentPage == i ? "green" : "",
            border: "1px solid",
          }}
          key={i}
          onClick={() => setSearchParams({ page: i })}
        >
          {i}
        </button>
      );
    }
    if (currentPage > pageCount && pageCount !== 0) {
      navigate("/statement");
    }
    return elements;
  }

  useEffect(
    filter,
    // eslint-disable-next-line
    [transactions, currentPage, transactionType, search]
  );

  useEffect(() => {
    if (isLoading && transactions.length !== 0) return;
    dispatch(fetchTransactions());
    // eslint-disable-next-line
  }, [dispatch]);

  if (isError)
    return (
      <Layout>
        <p className="error">Something Wrong!</p>
      </Layout>
    );
  return (
    <Layout>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          padding: "16px 48px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <label className="switch">
            <input
              checked={transactionType === "income"}
              onChange={handleToggle}
              type="checkbox"
            />
            <span className="slider round"></span>
          </label>
          <h5 style={{ textTransform: "uppercase" }}>{transactionType}</h5>
        </div>
        <form>
          <input
            onChange={handleSearch}
            style={{
              padding: "9px",
              borderRadius: "12px",
              border: 0,
              boxShadow: "0px 0px 2px 0px black",
              minWidth: "15vw",
            }}
            type="text"
            placeholder="Search"
          />
        </form>
      </div>
      <div>
        <ul>
          {list.map((transaction) => (
            <Transaction key={transaction.id} transaction={transaction} />
          ))}
        </ul>
      </div>
      <div style={{ display: "flex", gap: "16px" }}>
        <Pagination />
      </div>
    </Layout>
  );
}
